export default __webpack_public_path__ + "static/media/UniversLTStd-XBlackObl.b91c02dc.otf";